document.addEventListener("DOMContentLoaded", () => {
    let sliders = document.querySelectorAll('.big-projects__slider');
    sliders.forEach((slider) => {
        console.log(slider);
        let objectSlider = new BigProjectsSlider(slider);
        objectSlider.init();
    });
});

class BigProjectsSlider {
    constructor(slider) {
        this.slider = slider;
        this.isReversed = slider.querySelector('ul').getAttribute('data-reverse') === 'true'
        this.items = slider.querySelectorAll('li');
        this.index = 0;
        this.animate = false;
    }

    init() {
        this.bindArrows();
    }

    slide(direction) {
        if (this.animate) {
            return;
        }
        let slideCount = this.items.length;
        this.animate = true;

        if (direction === 'left') {
            this.index = (this.index - 1) < 0 ? this.index : (this.index - 1);
        } else if (direction === 'right') {
            this.index = (this.index + 1) > slideCount - 1 ? this.index : (this.index + 1);
        }
        this.removeImageClasses();
        this.items[this.index].classList.add('active');
        this.slider.querySelector('ul').style.left = (this.index * (157 * (this.isReversed ? 1 : -1))) + 'px';

        let that = this;
        setTimeout(function () {
            that.animate = false;
        }, 150);
    }

    removeImageClasses() {
        this.items.forEach(function (node) {
            node.classList.remove('active');
        })
    }

    bindArrows() {
        let buttons = this.slider.querySelectorAll('.navigations');
        buttons.forEach((buttonContainer) => {
            let leftArrow = buttonContainer.querySelector('.left');
            let rightArrow = buttonContainer.querySelector('.right');

            leftArrow.addEventListener('click', () => {
                this.slide('left');
            });
            rightArrow.addEventListener('click', () => {
                this.slide('right');
            });

        })

    }
}
